import React from 'react';
import { Autocomplete } from '@material-ui/lab';
const GuiAutoComplete = (props) => {
  const { options = [], ...restProps } = props;
  return <Autocomplete options={options} autoHighlight {...restProps} />;
};
export default GuiAutoComplete;
